import { render, staticRenderFns } from "./AppVoiceNotePlayer.vue?vue&type=template&id=35ccc467&scoped=true"
import script from "./AppVoiceNotePlayer.vue?vue&type=script&lang=js"
export * from "./AppVoiceNotePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ccc467",
  null
  
)

export default component.exports